const state = {
  notification: {
    className: '',
    message: '',
    show: false
  }
};

// getters
const getters = {};

// actions
const actions = {
  ERROR_NOTIFICATION: ({ commit }, payload) => {
    commit('SET_NOTIFICATION', {
      className: 'elr-alert-danger',
      message: payload,
      show: true
    });
  },
  SUCCESS_NOTIFICATION: ({ commit }, payload) => {
    commit('SET_NOTIFICATION', {
      className: 'elr-alert-success',
      message: payload,
      show: true
    });
  },
  UPDATE_NOTIFICATION: ({ commit }, payload) => {
    commit('SET_NOTIFICATION', payload.notification);
  },
  REMOVE_NOTIFICATION: ({ commit }) => {
    commit('SET_NOTIFICATION', {
      className: '',
      message: '',
      show: false
    });
  }
};

// mutations
const mutations = {
  SET_NOTIFICATION: (state, notification) => {
    state.notification.className = notification.className;
    state.notification.message = notification.message;
    state.notification.show = notification.show;
  }
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};
